import React from "react";
import ReactModal from "react-modal";

import { LoadingButton } from "../../../shared/loading-button";

const CONFIRM_CLOSE = "Your changes will not be saved. Close anyway?";

const CommissionModalShell = ({ isOpen, title, trip, dirty, canSave, saving, onSave, onClose, testId, children }) => {
  const handleClose = () => {
    if (saving) return;
    if (dirty && !window.confirm(CONFIRM_CLOSE)) return;
    onClose();
  };

  const subHeader = [trip?.tripTag, trip?.owner?.name].filter(Boolean).join(" · ");

  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={handleClose}
      style={{
        overlay: {
          zIndex: 999999,
          backgroundColor: "rgb(32 53 68 / 50%)",
        },
        content: {
          width: "auto",
          border: "none",
          maxWidth: "554px",
          minWidth: "calc(min(500px, 95vw))",
          borderRadius: "0",
          boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
        },
      }}
      appElement={document.getElementById("app")}
    >
      <div data-testid={testId}>
        <div className="modal-header tv-commission-modal-header">
          <div>
            <h4>{title}</h4>
            <div className="tv-commission-note">Trip: {subHeader || "-"}</div>
          </div>
          <button
            type="button"
            title="Close"
            className="tv-commission-modal-close"
            onClick={handleClose}
            data-testid="commission-modal-close"
          >
            <span className="material-icons">close</span>
          </button>
        </div>

        <div className="modal-body width-100">
          <form className="w-100 base-form mt-10" onSubmit={(event) => event.preventDefault()}>
            {children}
          </form>
        </div>

        <div className="modal-footer w-100 mt-10 d-flex gap-10">
          <LoadingButton
            type="button"
            className="base-button evo-blue flex-half"
            isLoading={saving}
            disabled={!canSave}
            onClick={onSave}
            data-testid="commission-modal-save"
          >
            Save Changes
          </LoadingButton>
          <button
            type="button"
            className="base-button btn-danger flex-half"
            onClick={handleClose}
            disabled={saving}
            data-testid="commission-modal-cancel"
          >
            Cancel
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default CommissionModalShell;
